import { ExportType } from '@components'

import { type ExportDocumentFileType } from '../../../types/exportDocumentFileType'

export const exportDocumentFileTypeToTKey: Record<ExportDocumentFileType, string> = {
  [ExportType.Csv]: 'export_drawer.format.csv',
  [ExportType.Xlsx]: 'export_drawer.format.xlsx',
}
